import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "us-west-2",
    aws_cognito_identity_pool_id: "us-west-2:8933d30f-0610-4b8d-9ec8-afa52ad0f4fe",
    aws_user_pools_id: "us-west-2_jr0syLccm",
    aws_user_pools_web_client_id: "1kekc4q2fahbp7em8866m597pm",
    Auth: {
      identityPoolId: "us-west-2:8933d30f-0610-4b8d-9ec8-afa52ad0f4fe",
      region: "us-west-2",
      userPoolId: "us-west-2_jr0syLccm",
      userPoolWebClientId: "1kekc4q2fahbp7em8866m597pm",
    },
    oauth: {
      domain: `whs-safer-beta-latam.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://beta.latam.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.latam.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
